import React, { useEffect, useState } from 'react'
import InvoiceService from '../../../../../services/api/invoice.service'
import InvoiceForm from '../invoice-form/InvoiceForm'
import APIResponse from '../../../../templates/components/APIResponse';
import VirtualTerminalForm from '../../transactions/terminals/virtual-terminal/virtual-terminal-form/VirtualTerminalForm';
import ModalBox from '../../../../templates/components/ModalBox';

const EditInvoice = (props) => {

    const [initialData, setInitialData] = useState()
    const [apiResponse, setApiResponse] = useState()
    const [nextOperation, setNextOperation] = useState(0)
    const [showVirtualTerminal, setShowVirtualTerminal] = useState(false)
    const [invoice, setInvoice] = useState()
    const [close, setClose] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const [toastOnSuccess, setToastOnSuccess] = useState(true)
    const closeHandler = () => {
        if (isLoader) return; // Prevent multiple submissions
        
        setIsLoader(true);
        setToastOnSuccess(true); // Show toast for closeHandler
        let reqObj = { closeReason: 'Close invoice' }
        InvoiceService.closeAndWriteOff(invoice?.id, reqObj)
            .then(res => {
                setClose(false);
                setApiResponse(res);
              })
            .catch(err => {
                setClose(false);
                setApiResponse(err);
            }).finally(() => {
                setIsLoader(false);
            });
    }

    const pullInvoice = () =>{
        setIsLoader(true);
        InvoiceService.getInvoiceById(props.id)
        .then(res=>{
            let newData = res
            setInitialData(newData)
        }).catch(err=>{
            console.log(err)
        }).finally(()=>{
            setIsLoader(false);
        })
    }

    const onSuccess = (message) => {

        if (nextOperation==1) {
            setNextOperation(0)
            setShowVirtualTerminal(true)
        } 
        else if (nextOperation==2) {
            setNextOperation(0)
            setClose(true)
        }
        else 
        {
            if (props.refresh) {
                props.refresh()
            }
            if (props.onClose) {
                props.onClose()
            }
            if (props.exitHandler) {
                props.exitHandler()
            }
        }

      }

    const editInvoice = (data, selectedPatient, items, providerId, invoiceType, virtualTerminal) => {
        if (isLoader) return; // Prevent multiple submissions
        
        //console.log("invoice edit "+JSON.stringify(data))
        setIsLoader(true)
        if (virtualTerminal) setNextOperation(1);
        return saveInvoice(data, selectedPatient, items, providerId)
            .then((res) => { 
                if (res?.data) setInvoice(res?.data);
                setApiResponse(res);
            })
            .catch((err) => { 
                setApiResponse(err);
                //console.log(err) 
            }).finally(() => {
                setIsLoader(false);
            });
    }

    const onCloseInvoice = (data, selectedPatient, items, providerId) => {
        if (isLoader) return; // Prevent multiple submissions
        
        //console.log("invoice close "+JSON.stringify(data))
        setIsLoader(true)
        setNextOperation(2);
        setToastOnSuccess(false); // Don't show toast for onCloseInvoice save
        return saveInvoice(data, selectedPatient, items, providerId)
            .then((res) => { 
                if (res?.data) setInvoice(res?.data);
                setApiResponse(res);
            })
            .catch((err) => { 
                setApiResponse(err);
                //console.log(err) 
            }).finally(() => {
                setIsLoader(false);
            });
    }

    const saveInvoice = (data, selectedPatient, items, providerId) => {
        //console.log("invoice save "+JSON.stringify(data))
        let reqObj = data
        reqObj.items = items.map(item => {
            let newItem = { ...item };
            if(item.itemType === 4 ) {
                //calculated from ui
                newItem.unitPrice = item.feesEachSubTotal ? parseFloat(item.feesEachSubTotal) : 0  
                newItem.taxAmount = item.feesEachTaxAmount ? parseFloat(item.feesEachTaxAmount) : 0
                delete newItem.doctorId
            }   
            else {
                newItem.unitPrice = item.unitPrice ? parseFloat(item.unitPrice) : 0
                //added from appointment create invoice has null doctorId, backend was throwing error 
                if (!newItem.doctorId) {
                    delete newItem.doctorId
                }
            }
            if (item.itemType === 6) {
                //tip item
                newItem.name = item.name || "Tip"
            } else {
                newItem.taxPercent = item.taxPercent ? parseFloat(item.taxPercent) : 0
                newItem.discount = item.discount ? parseFloat(item.discount) : 0
                newItem.quantity = item.quantity ? parseFloat(item.quantity) : 1
                newItem.feeAmount = item.feeAmount ? parseFloat(item.feeAmount) : 0
                newItem.feePercentage = item.feePercentage ? parseFloat(item.feePercentage) : 0
                newItem.discountType = newItem.discountType ? newItem.discountType : 1
            }
            newItem.chartNotesId = item.chartNotesId
            return newItem
        })
        reqObj.doctorId = items.find(obj => obj.doctorId !== undefined)?.doctorId || providerId
        reqObj.invoiceId = data.id
        reqObj.operationType = data.operationType || 2
        reqObj.autoClaimStatus = data.autoClaimStatus || false
        reqObj.practiceLocationId = data.practiceLocationId
        reqObj.patientName = data?.patientName ? data.patientName : selectedPatient.firstName+' '+selectedPatient?.lastName
        reqObj.patientId = selectedPatient?.id || data.patientId
        return InvoiceService.editInvoice(reqObj);
    }


    useEffect(()=>{
        pullInvoice()
    },[props.id])

    return (
        <div>
            {initialData && <InvoiceForm appointmentId={props.appointmentId || null} onCloseInvoice={onCloseInvoice} initialData={initialData} isModal  isEdit submitLabel="Add" submitHandler={editInvoice} onClose={() => { if (props.onClose) { props.onClose() } }} isLoader={isLoader}/>}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={toastOnSuccess}/>

            <ModalBox open={showVirtualTerminal && invoice} onClose={() => {
                setShowVirtualTerminal(false); 
                onSuccess()
            }}>
                <VirtualTerminalForm initialData={{ ...invoice, taxAmount: invoice?.itemTotalTax, adjustedUnpaidAmount: invoice?.adjustedUnpaidAmount ? invoice?.adjustedUnpaidAmount : invoice?.finalAmount }} 
                    onClose={() => {
                    setShowVirtualTerminal(false); 
                    onSuccess()
                }} size="large" isModal />
            </ModalBox>

            <ModalBox open={close} onClose={() => { setClose(false) }} size="tiny" title="Close Invoice">
                <div className='col-12'>
                    The invoice has been updated. Are you sure you want to close it?
                </div>
                <div className='col-12 d-flex justify-content-between mt-3'>
                    <div className='col-auto'>
                        <button
                            className='btn btn-primary'
                            onClick={(e) => { e.preventDefault(); closeHandler(); }}
                            disabled={isLoader}
                        >
                            Yes
                        </button>
                    </div>
                    <div className="col-auto">
                        <button 
                            className='btn btn-secondary' 
                            onClick={e => { e.preventDefault(); setClose(false) }}
                            disabled={isLoader}
                        >
                            No
                        </button>
                    </div>
                </div>
            </ModalBox>      

        </div>
    )
}
export default EditInvoice